import React from 'react';
import Page from '../../Components/Page';

const Recipe = () => {
  return (
    <Page className="text-center">
      <h2 className="text-2xl">Recipe</h2>
      <h3>Coming Soon</h3>
    </Page>
  );
};

export default Recipe;
